<!-- loading spinner -->
<div *ngIf="loading" class="text-center">
  <p-progressSpinner></p-progressSpinner>
</div>
<!-- form -->
<form *ngIf="!loading" [formGroup]="form" class="validated-form">

  <div class="field grid">
    <label class="col-fixed">Default Creditor Invoice Document Type</label>
    <div class="col-fixed dropdown-field">
      <p-dropdown hideDropdownOnScroll formControlName="DefaultCreditorInvoiceDocumentTypeCode" [options]="transactionTypes" dataKey='Code' optionLabel='Description'></p-dropdown>

    </div>
  </div>

  <div class="field grid">
    <div class="col">
      <p>
        Suggested Coding allows the system to help you find the correct creditors
        and property analysis for an invoice based on past transactions that have
        been processed over a given period.
      </p>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed">Allow Suggested Coding?</label>
    <div class="col">
      <p-inputSwitch formControlName="AllowSuggestedCoding"></p-inputSwitch>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed">Analysis History for (months):</label>
    <div class="col">
      <input type="text" mojoNumericInput formControlName="AnalysisPeriod" [min]="1" [max]="99" [format]="0">
    </div>
  </div>

  <div class="field grid">
    <div class="col">
      <span class="sub-header">Suggest Creditor if</span>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed">Creditor's own Account No used for property</label>
    <div class="col">
      <div class="pull-left">
        <input type="text" mojoNumericInput formControlName="CreditorPropertyThreshold" [min]="1" [max]="99" [format]="0"><br/>
        <span *ngIf="invalid('CreditorPropertyThreshold')" class="light-color">Must be a value of 1 to 99</span>
      </div>
      <span>time(s) or more during the given period.</span>
    </div>
  </div>

  <div class="field grid">
    <div class="col">
      <span class="sub-header">Suggest Property Analysis if</span>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed">Creditor and Property are known and a given analysis has been used:</label>
    <div class="col">
      <div class="pull-left">
        <input type="text" mojoNumericInput formControlName="ExpenseAnalysisThreshold" [min]="1" [max]="99" [format]="0"><br/>
        <span *ngIf="invalid('ExpenseAnalysisThreshold')">Must be a value of 1 to 99</span>
      </div>
      <span>time(s) or more during the given period.</span>
      </div>
  </div>

  <div class="field grid">
    <div class="col">
      <span class="sub-header">Suggest Expense Code if</span>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed">The Creditor is known and the given expense code has been used:</label>
    <div class="col">
      <div class="pull-left">
        <input type="text" mojoNumericInput formControlName="ExpenseCodeThreshold" [min]="1" [max]="99" [format]="0"><br/>
        <span *ngIf="invalid('ExpenseCodeThreshold')">Must be a value of 1 to 99</span>
      </div>
      <span>time(s) or more during the given period.</span>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed"></label>
    <div class="col" style="padding: 0">
      <button pButton label="Reset Defaults" (click)="resetToDefaults()" [disabled]="!resetButtonEnabled"></button>
    </div>
  </div>

</form>

<!-- dialogs -->

<p-confirmDialog #cd
  appendTo="body"
  closable='false'
  key='refreshLookupTableConfirmDialog'
  header="Generate Lookups?"
  message="Changes have been made to the settings for Creditor Invoice Suggested Coding.
           Would you like to generate/refresh the look up tables?">
  <p-footer>
      <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
      <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
      <hr/>
      <p style="text-align: left;">
        Note: Manual generation/refreshing of the Creditor Invoice Suggested Coding can also be
        done and scheduled from the Data Retrieval and Analysis menu which is found on the Tools
        menu in PM&A
      </p>
  </p-footer>
</p-confirmDialog>

<p-dialog
  appendTo="body"
  [modal]="true"
  [closeOnEscape]="false" [closable]="false"
  [draggable]="false" [resizable]="false"
  [(visible)]="lookupTableRefreshInProgress"
  header='Refreshing Lookup Tables'>
    <p>
      This may take a few mintues. <br/>
      Please do not navigate away from this page or updates may be lost.
    </p>
</p-dialog>

<p-dialog
  appendTo="body"
  [modal]="true"
  [closeOnEscape]="false" [closable]="false"
  [draggable]="false" [resizable]="false"
  [style]="{ width: '232px' }"
  [(visible)]="lookTableRefreshComplete"
  header="All done">
    <p>Lookup tables have been refreshed</p>
    <p-footer>
      <button type="button" pButton icon="pi pi-check" (click)="saveComplete(true)" label="Ok"></button>
  </p-footer>
</p-dialog>
